import React from "react";
import { TelephoneFill, QuestionCircleFill } from "react-bootstrap-icons"; // Bootstrap Icons
import question from "../../../assets/img/accessibility/question.svg";
import "./accessibility.css"; // Import your custom CSS for styling

function AccessibilityStatement() {
  return (
    <div className="accessContainer py-5">
      <h2 className="text-center fw-bold mb-4">Accessibility Statement</h2>

      <div className="mb-4">
        <p className="text-muted mt-2">
          United Automobile Insurance Accessibility (UAIC) is continually
          working to make its web content and mobile apps accessible as part of
          its online inclusion efforts. We are committed to providing a website
          that is built with accessibility in mind, so that no one, regardless
          of ability or disability is affected.
        </p>
        <p className="text-muted mt-2">
          UAIC will make every effort to ensure any new or updated website
          content produced, will conform with the World Wide Web Consortium
          (W3C) Web Accessibility Initiative's (WAI) Web Content Accessibility
          Guidelines (WCAG) 2.1, Level A & AA. To affirm our commitment, UAIC
          has invested in training for the designated individuals, such as
          website content editors and developers, in the functions of web
          accessibility tools, techniques and best practices. A cadence of
          Automated, Manual and Functional testing is currently being performed
          by a third party vendor to ensure compliance of the existing website,
          to detect WCAG 2.1 violations, which will be corrected to the best of
          our ability and tested by a team of users, including people with
          disabilities to ensure a great user experience for all. UAIC has
          brought on a third-party digital accessibility vendor, who is
          supporting the process by testing the web content and providing a
          roadmap and recommendations for remediation.
        </p>
        <p className="text-muted mt-2">
          UAIC's goal is to ensure that everyone has access to information on
          the site and mobile apps and can fully interact with them. We are
          currently working on our website and mobile apps to identify potential
          accessibility issues and we are striving to improve the usability of
          these digital properties for people of all abilities.
        </p>
        <p className="text-muted mt-2">
          The Assistive Technology app provided by eSSENTIAL Accessibility and
          featured on our website incorporates tools such as mouse and keyboard
          replacements, voice recognition, speech enablement,
          hands-free/touch-free navigation and more that empower the customer to
          overcome challenges and access UAIC's website and Android app with
          ease.
        </p>
      </div>

      <div className="bg-light border rounded-3 p-4">
        <div className="d-flex align-items-start flex-column flex-md-row">
          <div className="flex-grow-1">
            <div className="d-flex">
              <img
                src={question}
                alt="PC Icon"
                className="me-2"
                style={{ width: "35px", height: "35px" }}
              />
              <h5 className="fw-bold mb-1 border-bottom border-primary d-inline-block pb-1">
                Contact Us
              </h5>
            </div>
            <p className="mb-0 text-muted">
              If you have difficulty accessing our website or mobile apps, or if
              you have feedback on how we can improve your online experience,
              please contact us at
            </p>
          </div>

          {/* Move button to bottom on larger screens */}
          <div className="mt-3 mt-md-auto ms-md-3 align-self-start">
            <a
              href="tel:3059405022"
              className="btn btn-primary-login d-flex align-items-center"
            >
              <TelephoneFill className="me-2" style={{ color: "white" }} />
              <span style={{ color: "white" }}>(305) 940-5022</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccessibilityStatement;
